var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { useStyles } from './dz-editor.styles';
const DzMenuButton = (_a) => {
    var { children, isActive = false } = _a, rest = __rest(_a, ["children", "isActive"]);
    const classes = useStyles({});
    return (_jsx(Button, Object.assign({ color: "inherit", variant: isActive ? 'contained' : 'text', className: classes.menuButton }, rest, { children: children })));
};
export default DzMenuButton;
